import { render, staticRenderFns } from "./Vibration.vue?vue&type=template&id=640fa9d4&scoped=true"
import script from "./Vibration.vue?vue&type=script&lang=js"
export * from "./Vibration.vue?vue&type=script&lang=js"
import style0 from "./Vibration.vue?vue&type=style&index=0&id=640fa9d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640fa9d4",
  null
  
)

export default component.exports